/**
 * Chart color palette - Monochromatic purple
 *
 * All charts across the application MUST use these colors to maintain
 * visual consistency and a professional, cohesive look.
 *
 * Based on the Tailwind purple scale, from darkest to lightest.
 */

/** Primary chart colors (ordered darkest → lightest) */
export const CHART_COLORS = [
  '#7c3aed', // purple-600 (darkest)
  '#8b5cf6', // purple-500 (primary)
  '#a78bfa', // purple-400 (medium)
  '#c4b5fd', // purple-300 (lightest)
] as const;

/** Named exports for direct access */
export const CHART_COLOR_DARKEST = CHART_COLORS[0];
export const CHART_COLOR_PRIMARY = CHART_COLORS[1];
export const CHART_COLOR_MEDIUM = CHART_COLORS[2];
export const CHART_COLOR_LIGHTEST = CHART_COLORS[3];

/** Sparkline colors by trend direction */
export const SPARKLINE_COLORS = {
  up: CHART_COLOR_PRIMARY,
  down: CHART_COLOR_MEDIUM,
  neutral: CHART_COLOR_LIGHTEST,
} as const;
